import { useEffect, useState } from "react";
import { useI18n } from "../i18n/I18nContext";
import { ACTIVITIES, activityLabel } from "../data/activities";
import api from "../lib/api";
import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

let _divCache = null;
async function loadDivisions() {
  if (_divCache) return _divCache;
  const { data } = await api.get("/activities");
  _divCache = data.divisions_by_section || {};
  return _divCache;
}

export default function ActivitySelect({ value, onChange, divisionValue, onDivisionChange, testId, divisionTestId }) {
  const { t, lang } = useI18n();
  const [divs, setDivs] = useState({});
  useEffect(() => { loadDivisions().then(setDivs).catch(() => {}); }, []);

  const sectionDivs = value ? (divs[value] || []) : [];
  const dLabel = (d) => d[lang] || d.en;

  return (
    <div className="space-y-3">
      <div>
        <Label className="text-midnight text-sm">{t("common.activityLabel")}</Label>
        <Select value={value || ""} onValueChange={onChange}>
          <SelectTrigger className="mt-1.5 rounded-none border-sand" data-testid={testId}>
            <SelectValue placeholder={t("common.activitySelect")} />
          </SelectTrigger>
          <SelectContent className="rounded-none bg-white max-h-80">
            {ACTIVITIES.map((a) => (
              <SelectItem key={a.code} value={a.code}>{a.code} · {activityLabel(a.code, lang)}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {onDivisionChange && value && sectionDivs.length > 0 && (
        <div>
          <Label className="text-midnight text-sm">{t("common.subActivityLabel")}</Label>
          <Select value={divisionValue || ""} onValueChange={onDivisionChange}>
            <SelectTrigger className="mt-1.5 rounded-none border-sand" data-testid={divisionTestId}>
              <SelectValue placeholder={t("common.subActivitySelect")} />
            </SelectTrigger>
            <SelectContent className="rounded-none bg-white max-h-80">
              {sectionDivs.map((d) => (
                <SelectItem key={d.code} value={d.code}>{d.code} · {dLabel(d)}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
}
